import React from "react";
import arrow from './arrow-left.png';
import './BtVoltar.css';

export default class Button extends React.Component{
  render(){
    var _class = `${this.props.classes} bt-voltar`;
    return(
      <div>
        <a
          href='#'
          onClick={this.props.onClick}
          type={this.props.type}
          className={_class}
          disabled={this.props.disabled}
        >
        <img src={arrow} />
        <span>{this.props.text}</span>
        <div className='clear'></div>
       </a>
     </div>
    );
  }
}
/*
const Btvoltar = ({
  text="back",
  classes = "",
  ...props
}) => {
  var _class = classes+" pure-button button-large simples-button";
    return (
        <div>
        <a href='#' className='bt-voltar' onClick={this.props.onClick}>
          <img src={arrow} />
          <span>{text}</span>
          <div className='clear'></div>
        </a>
        </div>
    );
}

export default Btvoltar;*/



// WEBPACK FOOTER //
// ./src/components/buttons/Btvoltar.js